<div class="container">
    <div *ngIf="message  && message.text" [@fadeUpDown]="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">
        <button class="close" (click)="onDismiss()">X</button>
        {{message.text}}
    </div>
</div>
